import { render, staticRenderFns } from "./Bills.vue?vue&type=template&id=28d6cc4f&"
import script from "./Bills.vue?vue&type=script&lang=js&"
export * from "./Bills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports